import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['direct-files'],
  queryOptions: {},
};

const getDirectFiles = async (directID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/directs/${directID}/files?${queryString}`);

  return { files: data || [], total };
};

export const useDirectFiles = (directID, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, directID], () => getDirectFiles(directID, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};
